/**
 * Statsig gate for display currencies on the website (WHO-5142). On in development, testing and
 * production (production since 26 Oct 2026, WHO-6253; roll back by removing production from its
 * rule, and see `DISPLAY_CURRENCY_URL_REDIRECTS` in `middleware.ts`). Off, the web asks for no
 * currency and the gateway and search answer in each listing's own currency (EUR).
 *
 * ⚠️ Keep it targeted by environment only (its one rule is 100% public per environment). The
 * server checks it for one fixed user before rendering a `?currency=` page that the CDN then
 * serves to everyone (`displayCurrencyForPage`), so a percentage, country or user rule would be
 * decided once for all visitors, not per visitor.
 */
export const DISPLAY_CURRENCY_GATE = "web_display_currency";

/**
 * `DISPLAY_CURRENCY_FORCE_ENABLED=1`, a Vercel preview variable scoped to one branch, forces the
 * gate on there so the team can try it before the gate exists, as Open Home's
 * `OPEN_HOME_FORCE_ENABLED`. next.config.js exposes it to the browser. Never set in production.
 */
export const displayCurrencyForced = () =>
  process.env.NEXT_PUBLIC_DISPLAY_CURRENCY_FORCE_ENABLED === "1";

/**
 * Statsig event: which display currency a visitor sees prices in and why (WHO-6199, Thomas 22 Oct),
 * so the launch can weigh how many £/$ visitors picked a currency against how many were only
 * guessed from their country. Value: the currency. Metadata `source`: `picked` (their pick, or
 * their account's) or `guessed`. Once per browser session per source and currency.
 */
export const DISPLAY_CURRENCY_EVENT = "display_currency";
